export default class Animate{

   static elementAnimation = (id,xNum, yNum, xNumEnd, yNumEnd,scaleS,scaleE, pause, fade)=>{
        let element = document.getElementById(id);
        setTimeout(function(){  fade === "in" ? fadeIn(element) : fadeOut(element);
            animateObjects(element,xNum, yNum, xNumEnd, yNumEnd, scaleS, scaleE);
           
        },pause);
    }
   static  animateObjects=  (element,xNumS, yNumS, xNumE, yNumE, scaleS, scaleE) =>{
        element.animate([
            { transform: `translate(${xNumS}, ${yNumS}) scale(${scaleS})`},
            {transform: `translate(${xNumE}, ${yNumE}) scale(${scaleE})`}
          ], {
    
            duration: 1200,
            iterations: 1
          }, );
         
    }
    
     static fadeIn =(element) =>{
        
        let opacity = 0;
        let intervalID = setInterval(function() {
    
            if (opacity < 1) {
                opacity = opacity + 0.2
                element.style.opacity = opacity;
            } else {
                clearInterval(intervalID);
            }
        }, 200);
    
    }
    
    static fadeOut = (element) =>{
        let opacity = 1;
        let intervalID = setInterval(function() {
    
            if (opacity > 0) {
                opacity = opacity - 0.2
                element.style.opacity = opacity;
            } else {
                clearInterval(intervalID);
            }
        }, 200);
    }
    
}